import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import { ExclusiveDealResponseDto } from './use-get-exclusive-deals-api';

const endpoint = 'ums/v1/cms/exclusive-deals';
export const getExclusiveDealEndpointIdentifier = endpoint;

interface ResponseData {
  data: ExclusiveDealResponseDto;
}

type TData = ResponseData;
type TError = AxiosError;
type TQueryKey = [typeof endpoint, number];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetExclusiveDealApi(dealId: number, options?: Options): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(`${endpoint}/${dealId}`);

      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useQueryWrapper([endpoint, dealId], queryFn, {
    enabled: isLoggedIn && !!dealId,
    ...options,
  });
}
